import React from "react"
import { ControlLabel, FormControl, FormGroup, HelpBlock } from "react-bootstrap"

export default function FieldGroupSelect({ controlId, validationState, label, value, onChange,
  options, helpText, placeholder, className, withEmptyOption, disabled }) {
  return (
    <FormGroup controlId={ controlId } validationState={ validationState }>
      <ControlLabel>{ label }</ControlLabel>
      <FormControl componentClass="select" placeholder={ placeholder }
        value={ value } className={ className } disabled={ disabled }
        onChange={e => onChange(e.target.value)}>
        { withEmptyOption && <option value='' title=''></option>}
        { options.map((option, index) =>
          <option key={ index } value={ option.value } title={ option.title }>{ option.title }</option>)}
      </FormControl>
      <HelpBlock>{ helpText }</HelpBlock>
    </FormGroup>
  )
}


// WEBPACK FOOTER //
// ./src/components/fragments/FieldGroupSelect.js